<template>
  <div class="table-wrapper">

    <table
      border="1"
      cellspacing="0"
      cellpadding="6"
      class="report-table"
    >

      <thead>

        <tr>

          <th rowspan="2">所属授权公司</th>

          <th colspan="2">0业绩</th>
          <th colspan="2">1万以下</th>
          <th colspan="2">1-5万</th>
          <th colspan="2">5-10万</th>
          <th colspan="2">10-20万</th>
          <th colspan="2">20-50万</th>
          <th colspan="2">50-100万</th>
          <th colspan="2">100万以上</th>
          <th colspan="2">合计</th>

        </tr>

        <tr>

          <th>店数</th>
          <th>占比</th>

          <th>店数</th>
          <th>业绩</th>

          <th>店数</th>
          <th>业绩</th>

          <th>店数</th>
          <th>业绩</th>

          <th>店数</th>
          <th>业绩</th>

          <th>店数</th>
          <th>业绩</th>

          <th>店数</th>
          <th>业绩</th>

          <th>店数</th>
          <th>业绩</th>

          <th>店数</th>
          <th>业绩</th>

        </tr>

      </thead>

      <tbody>

        <tr
          v-for="row in data"
          :key="row.companyName"
        >

          <td>{{ row.companyName }}</td>

          <td>{{ row.zero.count }}</td>
          <td>{{ row.zero.rate }}</td>

          <td>{{ row.lt1.count }}</td>
          <td>{{ formatMoney(row.lt1.amount) }}</td>

          <td>{{ row.r1_5.count }}</td>
          <td>{{ formatMoney(row.r1_5.amount) }}</td>

          <td>{{ row.r5_10.count }}</td>
          <td>{{ formatMoney(row.r5_10.amount) }}</td>

          <td>{{ row.r10_20.count }}</td>
          <td>{{ formatMoney(row.r10_20.amount) }}</td>

          <td>{{ row.r20_50.count }}</td>
          <td>{{ formatMoney(row.r20_50.amount) }}</td>

          <td>{{ row.r50_100.count }}</td>
          <td>{{ formatMoney(row.r50_100.amount) }}</td>

          <td>{{ row.gt100.count }}</td>
          <td>{{ formatMoney(row.gt100.amount) }}</td>

          <td>{{ row.total.count }}</td>
          <td>{{ formatMoney(row.total.amount) }}</td>

        </tr>

      </tbody>

    </table>

  </div>
</template>

<script>
export default {

  props: {
    data: {
      type: Array,
      default: () => []
    }
  },

  methods: {

    formatMoney(value) {

      return Number(value || 0)
        .toLocaleString()

    }

  }

}
</script>

<style scoped>

.table-wrapper{
  margin-top:20px;
  overflow-x:auto;
}

.report-table{
  min-width:1800px;
  border-collapse:collapse;
}

.report-table th{
  background:#c00000;
  color:#fff;
}

.report-table td,
.report-table th{
  text-align:center;
  padding:8px;
}

</style>